import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=bc961dc2&"
import script from "./TagSelect.vue?vue&type=script&lang=js&"
export * from "./TagSelect.vue?vue&type=script&lang=js&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=bc961dc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports